export default __webpack_public_path__ + "static/media/ShareholderMeetingFAQ.ede01ead.pdf";